<template>
  <div class="container">
        <v-dialog v-model="dialog" width="800" persistent>
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
              Cambios realizados
            </v-card-title>

            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-list two-line>
                    <template v-for="(item, index) in ghistoricos">
                      <v-list-item avatar ripple v-bind:key="item.idauditoria">
                        <v-list-item-content>
                          <v-list-item-title :style="color(item)"
                            >{{ item.idcampoNavigation.nombre }}:
                          </v-list-item-title>
                          <v-list-item-sub-title
                            class="grey--text text--darken-4"
                            v-if="!item.cambio"
                            >{{ item.valor }}</v-list-item-sub-title
                          >
                          <v-list-item-sub-title
                            class="grey--text text--darken-4"
                            v-else
                            >{{ item.valor }}
                            <p style="color: black"><b>Valor anterior:</b></p>
                            <p style="color: red">
                              {{ item.anterior }}
                            </p></v-list-item-sub-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider
                        v-if="index + 1 < ghistoricos.length"
                        :key="index"
                      ></v-divider>
                    </template>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialog = false"> Cerrar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogSoportes" width="800" persistent>
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
              Soportes de la versión
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col xs12 sm6 md6>
                  <v-text-field
                    :readonly=!this.puedeeditar()
                    data-vv-name="numeroradicado"
                     v-model="versionadodatosadicionales.numeroradicado"
                    label="Número radicado"
                    :clearable="this.puedeeditar()"
                    v-validate="'required|numeric'"
                    :counter="50"
                    data-vv-scope="versionadodatosadicionales"
                    :error-messages="errors.collect('numeroradicado', 'versionadodatosadicionales')"
                  ></v-text-field>
                </v-col>
                <v-col xs12 sm6 m6>
                  <v-menu
                    ref="fecha"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    readonly
                  >
                    <template v-slot:activator="{ on }">
                      <div v-if="puedeeditar()">
                        <v-text-field
                          v-model="fechaformateada"
                          label="Fecha radicado:"
                          prepend-icon="event"
                          v-on="on"
                          v-validate="'required'"
                          data-vv-name="fecharadicado"
                          data-vv-scope="versionadodatosadicionales"
                          :error-messages="errors.collect('fecharadicado', 'versionadodatosadicionales')"
                          @blur="fecharadicado = parseDate(fechaformateada, true)"
                        ></v-text-field>
                      </div>
                      <div v-else>
                        <v-text-field
                          :readonly=true
                          v-model="fechaformateada"
                          label="Fecha radicado:"
                        ></v-text-field>
                      </div>
                    </template>
                    <div v-if="this.puedeeditar()">
                    <v-date-picker
                      v-model="fecharadicado"
                      no-title
                      scrollable
                      locale="es"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu = false"
                        >Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        readonly
                        @click="$refs.fecha.save(fechaformateada)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                    </div>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs12 sm12 m12>
                  <v-textarea
                    :readonly=!this.puedeeditar()
                    v-model="versionadodatosadicionales.comentario"
                    label="Comentario:"
                    v-validate="'required'"
                    data-vv-name="comentario"
                    data-vv-scope="versionadodatosadicionales"
                    :error-messages="errors.collect('comentario', 'versionadodatosadicionales')"
                    :clearable="this.puedeeditar()"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs12 sm12 m12>
                  <v-data-table
                    :headers="headerFieldsSoportes"
                    :items="soportes"
                    class="elevation-2"
                    :no-data-text="gnodata"
                    dense
                    :items-per-page="10"
                  >
                  <template v-slot:item.action="{ item }">
                    <v-tooltip top v-show="puedeeditar()">
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          small
                          class="mr-2"
                          @click="deletesoporteversion(item)"
                        >delete</v-icon>
                      </template>
                      <span>Eliminar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small class="mr-2" @click="descargarsoporte(item)">mdi-file</v-icon>
                      </template>
                      <span>Descargar</span>
                    </v-tooltip>
                  </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-flex row v-show=this.puedeeditar()>
                <v-flex xs12 md10 sm10>
                  <template>
                    <v-file-input
                      accept=".pdf, .xlsx, .xls"
                      v-model="fileversionadosoporte"
                      show-size
                      multiple
                      label="cargar archivo"
                      @change="onVersionadoSoporteChange"
                    ></v-file-input>
                  </template>
                </v-flex>
                <v-flex xs12 md2 sm2>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          outlined
                          v-on="on"
                          class=ma-2
                          @click="Addversionadosoporte"
                          tile
                          color="success"
                        >
                          <v-icon left>add</v-icon>Agregar
                        </v-btn>
                      </template>
                      <span>Agregar archivo</span>
                    </v-tooltip>
                </v-flex>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn class="text-white" color="blue darken-1" @click="cancel">Cancelar</v-btn> -->
              <v-btn class="text-white" color="blue darken-1" @click="preventguardardatosadicionales" v-show="this.puedeeditar()">Guardar</v-btn>
            </v-card-actions>
          </v-card>
          <v-snackbar
            v-model="snack"
            :timeout="timeoutsnak"
            :color="MesaggeInfo.color"
          >
            {{ this.MesaggeInfo.codigoRespuesta }}
            {{ this.MesaggeInfo.mensajeRespuesta }}
            <v-btn text @click="functionalert">{{ buttontext }}</v-btn>
            <v-btn text v-show="snackalert" @click="cancelsave">Cancelar</v-btn>
          </v-snackbar>
        </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import store from "../../stores/index.js";
import moment from "moment";
import { ErrorBag } from 'vee-validate';
export default {
  name: "auditoriasoportes",
  props: {
    idtabla: Array
  },
  data() {
    return {
      fecharadicado: new Date().toISOString().substr(0, 10),
      fechaformateada: '',
      fecharadicadoseleccionada: null,
      imageUrlversionadosoporte: null,
      selectedversionado: 0,
      fileversionadosoporte: null,
      versiones: [],
      version: [],
      soportes: [],
      versionadodatosadicionales: {numeroradicado:'', fecharadicado:'',comentario:'', fecharadicadoformateada:''},
      dialog: false,
      dialogSoportes: false,
      cargando: false,
      menu: false,
      tiposarchivo: null,
      headerFields: [
        {
          value: "idregistro",
          text: "Registro",
          sortable: true,
          width: "150px",
        },
        {
          value: "fecha",
          text: "Fecha",
          sortable: true,
          width: "30%",
        },
        {
          value: "numero",
          text: "Versión",
          sortable: true,
          width: "15%",
        },
        {
          value: "usuario",
          text: "Usuario",
          sortable: true,
          width: "150px",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          width: "100px",
          align: "center",
        },
        
      ],
      headerFieldsSoportes: [
        {
          value: "nombrearchivo",
          text: "Nombre",
          sortable: true,
          width: "150px",
        },
        { text: "Acciones", value: "action", sortable: false, width: "10%" }
      ],
      snack: false,
      snackalert: false,
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      timeoutsnak: 4000,
      buttontext: "cerrar",
      dictionary: {
        custom: {
          numeroradicado: {
            required: () => "El número del radicado es un campo obligatorio",
            numeric: () => "El número del radicado de ser númerico",
            max: "está superando el límite de caracteres",
          },
          fecharadicado: {
            required: () => "La fecha del radicado es un campo obligatorio",
            alpha_spaces: "Los valores ingresados",
          },
          comentario: {
            required: () => "El comentario del radicado es un campo obligatorio",
            alpha_spaces: "Los valores ingresados",
          },
        },
      },
      deletesoporteVersion:[]
    }
  },
  methods: {
    ...mapActions([
      // "put_soportesversion",
      "put_historicoversionado",
      "downloadsoporteversion",
      "get_configuraciones",
      "putversionadodatosadicionalestablas",
      "get_porusuario",
    ]),
    ...mapActions("usuario/", ["get_usuarios"]),
    ...mapActions("carga/", ["post_cargararchivote"]),
    mostrarPopupCambio() {
      // this.get_ultimoversionadotabla({
      //   params: { idtabla: this.idtabla },
      // });
      this.dialogSoportes= true && this.puedeeditar();
    },
    cambio(item) {
      if (item.anterior === "") return item.valor;
      else return item.valor + "  <- " + item.anterior;
    },
    color(item) {
      if (item.cambio === true) {
        return "color:red";
      } else {
        return "color:black";
      }
    },
    formato(value, sinhora) {
      if (value && !sinhora) {
        return moment(String(value)).format("DD/MM/YYYY HH:mm");
      }
      else
      {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    datousuario(idusuario) {
      if (this.gusuarios !== undefined)
      {
          let usuariofiltrado = this.gusuarios.filter((p) => p.idusuario === idusuario);
          if(usuariofiltrado.length > 0) 
            return usuariofiltrado[0].login;
      }
      else return "Anonimo";
    },
    getusuario() {
      if (localStorage.usuario !== undefined) {
        return JSON.parse(unescape(localStorage.usuario));
      } else {
        return null;
      }
    },
     puedeeditar(){
      let opciones = this.gopciones.filter(
        p =>
          p.codigo === "O004-1-8"
      )[0];
      return opciones != undefined;
    },
    deletesoporteversion(item) {
      const index = this.soportes.indexOf(item);
      if (confirm("Desea eliminar el soporte?")) {
        this.deletesoporteVersion.push(item);
        this.soportes.splice(index, 1);
      }
    },
    descargarsoporte(item) {
      if (item.archivocompleto == null) {
        this.downloadsoporteversion({
          params: {
            idtabla: this.idtabla[0],
            idindicador: this.idregistro,
            idsoporte: item.idsoporte
          }
        });
      } else {
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        a.href = item.archivocompleto;
        a.setAttribute("download", item.nombrearchivo);
        a.click();
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      }
    },
    onVersionadoSoporteChange() {
      this.imageUrlversionadosoporte = [];
      let error = false;
      if (this.fileversionadosoporte !== null) {
        for (let i = 0; i < this.fileversionadosoporte.length; i++) {
          if (error === false) {
            let file = this.fileversionadosoporte[i];
            let tipo = file.type.replace("application/", "");
            if (this.tiposarchivo.indexOf(tipo, 0) > 0) {
              if (file.size > this.tamanoarchivo * 1024000) {
                this.MesaggeInfo.mensajeRespuesta =
                  "El tamaño de uno de los archivos supera el límite de carga (" +
                  this.tamanoarchivo +
                  "Mb)";
                this.MesaggeInfo.color = "errorvue";
                this.snack = true;
                error = true;
              } else {
                let actual = this.soportes.filter(
                  p =>
                    p.nombrearchivo === file.name &&
                    (p.idversionado === this.selectedversionado)
                )[0];
                if (actual === undefined) {
                  let reader = new FileReader();
                  reader.onload = () => {
                    this.imageUrlversionadosoporte.push(reader.result);
                  };
                  reader.readAsDataURL(file);
                } else {
                  this.MesaggeInfo.mensajeRespuesta =
                    "Uno de los archivos ya se encuentra relacionado en la versión";
                  this.MesaggeInfo.color = "errorvue";
                  this.snack = true;
                  error = true;
                }
              }
            } else {
              this.MesaggeInfo.mensajeRespuesta =
                "Uno de los archivos no es compatible con los tipos permitidos";
              this.MesaggeInfo.color = "errorvue";
              this.snack = true;
              error = true;
            }
          }
        }
        if (error === true) {
          this.imageUrlversionadosoporte = [];
          this.fileversionadosoporte = [];
        }
      }
    },
    Addversionadosoporte() {
      if (this.fileversionadosoporte !== null) {
        for (let i = 0; i < this.fileversionadosoporte.length; i++) {
          let file = this.fileversionadosoporte[i];

          this.soporteversion = Object.assign({}, this.soportes);
          this.soporteversion.nombrearchivo = file.name,
          this.soporteversion.tipoarchivo = file.type,
          this.soporteversion.finalizado = false,
          this.soporteversion.archivocompleto = this.imageUrlversionadosoporte[i],
          this.soporteversion.idsoporte = 0
          
          this.soportes.push(this.soporteversion);
        }
        this.imageUrlversionadosoporte = [];
        this.fileversionadosoporte = [];
      } else {
        this.MesaggeInfo.mensajeRespuesta =
          "Seleccione un archivo para la carga";
        this.MesaggeInfo.color = "infovue";
        this.snack = true;
      }
    },
    preventguardardatosadicionales() {
      this.$validator.validateAll("versionadodatosadicionales").then((result) => {
        if (!result || this.soportes.length == 0) {
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";
          
          let bag = new ErrorBag();
          bag = this.errors;
          if(bag.first('fileversionadosoporte', 'versionadodatosadicionales') !== undefined)
            bag.removeById(bag.first('fileversionadosoporte', 'versionadodatosadicionales').id);
          //bag.remove(bag.first('fileversionadosoporte').id);
         
          if(this.soportes.length == 0 && bag.first('fileversionadosoporte', 'versionadodatosadicionales') == undefined)
          {
            bag.add({
                scope: 'versionadodatosadicionales',
                field: 'fileversionadosoporte',
                msg: 'Al menos un archivo de soporte es requerido'
            });
          }
          
          this.$validator.errors.items.forEach((element) => {
            if(element.scope == "versionadodatosadicionales")
              Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "la validación del formulario contiene errores " + Errores;
          this.MesaggeInfo.color = "infovue";
          
          return;
        } else {
          
          this.Editarentidad = false;
          this.Savesoportedatosadicionales();
        }
      });
    },
    async Savesoportedatosadicionales(){
      this.loading = true;
      let bytes = window.crypto.getRandomValues(new Uint8Array(32));
      const randomBytes = () => (bytes = bytes.slice(1)) && bytes[0];
      let tran = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ (randomBytes() & (15 >> (c / 4)))).toString(16)
      );
      let errorcarga = false;
      // if (this.soporteversion != null) {
      //     await this.post_cargararchivote({
      //       archivo: this.soportes,
      //       idtransaccion: tran,
      //       tamanopaquete: this.tamanopaquete
      //     }).then(function() {});
      //     errorcarga = this.gerrorcarga;
      //   }
    await this.putversionadodatosadicionalestablas({
          data: {
            idtabla: this.idtabla, 
            versionadoDatosAdicionales: {
                                        idversionadodatosadicionales: this.versionadodatosadicionales.idversionadodatosadicionales,
                                        comentario: this.versionadodatosadicionales.comentario,
                                        numeroradicado: this.versionadodatosadicionales.numeroradicado,
                                        fecharadicado: this.versionadodatosadicionales.fecharadicado
                                        }, 
            soportesVersionado: this.soportes,
            soportesEliminar : this.deletesoporteVersion
            }
      });

      this.deletesoporteVersion = [];
       this.dialogSoportes = false;
    },
    functionalert() {
      if (this.buttontext == "cerrar") {
        this.snack = false;
      }
      if (this.buttontext == "aceptar") {
        this.snack = false;
        this.snackalert = false;
        this.timeoutsnak = 4000;
        this.buttontext == "cerrar";
        this.Savesoportedatosadicionales();
      }
    },
    cancel(){
      this.versionadodatosadicionales = {numeroradicado:'', fecharadicado:'',comentario:'', fecharadicadoformateada:''};
      this.fechaformateada = '';
      this.dialogSoportes = false;
    },
    cancelsave() {
      this.snackalert = false;
      this.snack = false;
      this.buttontext = "cerrar";
      this.timeoutsnak = 4000;
    },
    parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
  },
  computed: {
    ...mapGetters(["gversionados", "ghistoricos", "gconfiguraciones", "gopciones"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ...mapGetters("usuario", ["gusuario", "gusuarios"]),
    ...mapGetters("carga", ["gerrorcarga"]),
  },
  created() {
    this.get_porusuario();
    this.get_configuraciones();
  },
  $_veeValidate: {
    validator: "new",
  },
  mounted() {
    this.$validator.localize("es", this.dictionary);
  },
  watch: {
    gversionado() {
      this.version = this.gversionado;
    },
    gversionados: function () {
      this.cargando = false;
      this.versiones = this.gversionados;
      
    },
    gconfiguraciones() {
      this.tiposarchivo = this.gconfiguraciones.filter(
        p => p.codigo === "TiposArchivo"
      )[0].valor;
      this.tamanoarchivo = this.gconfiguraciones.filter(
        p => p.codigo === "TamanoArchivo"
      )[0].valor;
      this.tamanopaquete = this.gconfiguraciones.filter(
        p => p.codigo === "TamanoPaquete"
      )[0].valor;
      let GetConfigtime = this.gconfiguraciones.filter(
        X => X.codigo == "TiempoEspera"
      )[0];
      if (GetConfigtime != undefined) {
        this.timewait = GetConfigtime.valor;
      }
    },
    ginformation: function() {
      if (this.loading) {
        
        this.MesaggeInfo = this.ginformation;
        this.snack = true;
        //este console por favor dejarlo, es para que el usuario tenga en consola los posibles mensajes por si no alcanza a leerlo
        console.log(this.MesaggeInfo.mensajeRespuesta);
        this.loading = false;
        if(this.MesaggeInfo.mensajeRetorno == "1")
          this.dialogSoportes = false;
      }
    },
    versionadodatosadicionales(){
      if(this.versionadodatosadicionales.fecharadicadoformateada!= '')
      {
        this.fechaformateada = this.formato(this.versionadodatosadicionales.fecharadicadoformateada, true);
      }
    },
    fecharadicado () {
      if(this.fecharadicado != '')
      {
         this.fechaformateada = this.formato(this.fecharadicado, true);
         this.versionadodatosadicionales.fecharadicado = this.fecharadicado;
      }
    },

  },
}
</script>